var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

import * as React from 'react';
import { EventInjector } from "./Injector";
import { eventTypes } from "./propTypes";
var ACTIVE = {
  passive: false
};

var ActiveListener = function (_super) {
  __extends(ActiveListener, _super);

  function ActiveListener() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.ref = React.createRef();

    _this.addEventListener = function (name, cb, options) {
      if (_this.ref.current) {
        _this.ref.current.addEventListener(name, cb, options);
      }
    };

    _this.removeEventListener = function (name, cb, options) {
      if (_this.ref.current) {
        _this.ref.current.removeEventListener(name, cb, options);
      }
    };

    return _this;
  }

  ActiveListener.prototype.render = function () {
    return React.createElement(EventInjector, __assign({}, this.props, {
      settings: ACTIVE,
      ref: this.ref
    }));
  };

  ActiveListener.propTypes = __assign({}, eventTypes);
  return ActiveListener;
}(React.Component);

export { ActiveListener };